export const INITIAL_STATE = {
  user: {},
  userExp: [],
  pjCityBusUserExp: [],
  tripScheduler: []
};